<template lang="pug">
.c-progress-form__element
  label.c-progress-form__title(v-html="$t(`profiles.questions.${attribute}`)")
  .c-multiple-choice
    .row.c-multiple-choice__options
      .column.c-multiple-choice__item.c-multiple-choice__item--icon
        input.c-multiple-choice__radio(type="radio" :value="true" :name="attribute" :id="trueId" v-model="yesNoQuestion")
        label.c-multiple-choice__label(:for="trueId")
          Icon(:icon="yes_icon", classes="c-multiple-choice__icon")
          | Oui
      .column.c-multiple-choice__item.c-multiple-choice__item--icon
        input.c-multiple-choice__radio(type="radio" :value="false" :name="attribute" :id="falseId" v-model="yesNoQuestion")
        label.c-multiple-choice__label(:for="falseId")
          Icon(:icon="no_icon", classes="c-multiple-choice__icon")
          | Non
</template>

<script>
import Icon from '../shared/Icon'

export default {
  props: {
    attribute: '',
    yes_icon: {
      default: 'choice-check'
    },
    no_icon: {
      default: 'choice-cross'
    }
  },
  components: {
    Icon
  },
  computed: {
    yesNoQuestion: {
      get () {
        return this.$store.state.person[this.attribute]
      },
      set (value) {
        this.$store.commit('updatePersonInfo', {name: this.attribute, value: value})
      }
    },
    trueId () {
      return `${this.attribute}_true`
    },
    falseId () {
      return `${this.attribute}_false`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profiles/YesNoQuestion.vue